var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9078 3.25C13.9078 2.5625 13.3516 2 12.6641 2H2.66406C1.97656 2 1.41406 2.5625 1.41406 3.25V10.75C1.41406 11.4375 1.97656 12 2.66406 12H11.4141L13.9141 14.5L13.9078 3.25ZM12.6641 3.25V11.4812L11.9328 10.75H2.66406V3.25H12.6641ZM11.4141 8.25H3.91406V9.5H11.4141V8.25ZM3.91406 6.375H11.4141V7.625H3.91406V6.375ZM11.4141 4.5H3.91406V5.75H11.4141V4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/msg.efebfb364a3d7d3e83cb2174600c57ee.svg";
export { ForwardRef as ReactComponent };